/* =========================================================
   YETKİ ŞABLONLARI
   Kullanıcı Yönetimi sayfasında hızlı yetki vermek için kullanılır
========================================================= */

const allPages = {
  home: true,
  shopping: true,
  calendar: true,
  finance: true,
  tasks: true,
  sharedExpenses: true,
  health: true,
  harita: true,
  children: true,
  chat: true,
  documents: true,
  nePisirsam: true,
  activity: true,
  assistant: true,
  userManagement: true,
};

const standartPages = {
  ...allPages,
  userManagement: false,
};

const allActions = {
  /* Alışveriş */
  addShopping: true,
  deleteOwnShopping: true,
  deleteAllShopping: true,
  /* Takvim */
  addCalendarEvent: true,
  updateOwnCalendarEvent: true,
  updateAllCalendarEvents: true,
  deleteOwnCalendarEvent: true,
  deleteAllCalendarEvents: true,
  /* Finans */
  addFinance: true,
  deleteOwnFinance: true,
  deleteAllFinance: true,
  /* Görevler */
  addTask: true,
  completeOwnTask: true,
  completeAllTasks: true,
  deleteOwnTask: true,
  deleteAllTasks: true,
  /* Ortak Harcama */
  addSharedExpense: true,
  deleteOwnSharedExpense: true,
  deleteAllSharedExpense: true,
  /* Sağlık */
  addHealthRecord: true,
  deleteOwnHealthRecord: true,
  deleteAllHealthRecords: true,
  /* Harita */
  addMapPlace: true,
  deleteOwnMapPlace: true,
  deleteAllMapPlaces: true,
  shareLocation: true,
  /* Çocuk */
  addChildRecord: true,
  deleteOwnChildRecord: true,
  deleteAllChildRecords: true,
  /* Sohbet */
  sendMessage: true,
  editOwnMessage: true,
  deleteOwnMessage: true,
  deleteAllMessages: true,
  pinMessage: true,
  sendMedia: true,
  reactMessage: true,
  /* Belgeler */
  addDocument: true,
  deleteOwnDocument: true,
  deleteAllDocuments: true,
  /* Bugün Ne Pişirsem */
  generateMealSuggestion: true,
  rateMealSuggestion: true,
  manageMealSuggestions: true,
  /* Yönetim / Sistem */
  addCategory: true,
  manageUsers: true,
  sendFamilyNotification: true,
  manageScheduledNotifications: true,
  manageNotificationAutomation: true,
  sendSystemAnnouncement: true,
};

const standartActions = {
  ...allActions,
  deleteAllShopping: false,
  completeAllTasks: false,
  deleteAllTasks: false,
  deleteAllFinance: false,
  deleteAllSharedExpense: false,
  updateAllCalendarEvents: false,
  deleteAllCalendarEvents: false,
  deleteAllHealthRecords: false,
  deleteAllMapPlaces: false,
  deleteAllChildRecords: false,
  deleteAllMessages: false,
  pinMessage: false,
  deleteAllDocuments: false,
  manageMealSuggestions: false,
  addCategory: false,
  manageUsers: false,
  sendFamilyNotification: false,
  manageScheduledNotifications: false,
  manageNotificationAutomation: false,
  sendSystemAnnouncement: false,
};

const noActions = Object.fromEntries(Object.keys(allActions).map((key) => [key, false]));

export const permissionTemplates = {
  tamYetkili: {
    name: "Tam Yetkili",
    permissions: {
      pages: { ...allPages },
      actions: { ...allActions },
    },
  },

  standartUye: {
    name: "Standart Üye",
    permissions: {
      pages: { ...standartPages },
      actions: { ...standartActions },
    },
  },

  cocukProfili: {
    name: "Çocuk Profili",
    permissions: {
      pages: {
        ...standartPages,
        finance: false,
        sharedExpenses: false,
        documents: false,
        harita: false,
        assistant: false,
        userManagement: false,
      },
      actions: {
        ...noActions,
        completeOwnTask: true,
        sendMessage: true,
        editOwnMessage: true,
        deleteOwnMessage: true,
        reactMessage: true,
        generateMealSuggestion: true,
        rateMealSuggestion: true,
      },
    },
  },

  sadeceGoruntule: {
    name: "Sadece Görüntüle",
    permissions: {
      pages: { ...standartPages },
      actions: {
        ...noActions,
        reactMessage: true,
        generateMealSuggestion: true,
      },
    },
  },
};

/* =========================================================
   VARSAYILAN YETKİ — Yeni katılan kullanıcıya otomatik verilir
   Yönetici olmayan kullanıcı Yönetim hariç tüm sayfaları görür.
========================================================= */
export const defaultPermissions = permissionTemplates.standartUye.permissions;

/* =========================================================
   YÖNETİCİ YETKİSİ — Aileyi oluşturan kullanıcıya verilir
========================================================= */
export const adminPermissions = permissionTemplates.tamYetkili.permissions;
